/** Sales team contacts shown in the top bar and on the contact page. */
export const SALES_TEAM = [
  { name: 'Vishal', display: '+91 77430 05242', tel: '+917743005242' },
  { name: 'Anu Jain', display: '+91 78888 30138', tel: '+917888830138' },
  { name: 'Sneha', display: '+91 98777 91548', tel: '+919877791548' },
];

export default SALES_TEAM;
